module.exports = __webpack_public_path__ + "static/media/stool-1.1d12569c.png";